import { runWorker } from './runWorker';
import { trackDataChanges } from './trackDataChanges';
import { keyBy } from '../utils/keyBy';
export const calculateMetrics = async ({
  fetchPromise,
  cacheLoadPromise,
  namespace,
  entityName,
  cacheKey,
  segment,
  resolvePortalAndUserId,
  metricsConfig: {
    normalizeForPatchDiffing = input => input
  } = {}
}) => {
  const [fetchResult, cacheLoadResult] = await Promise.allSettled([fetchPromise, cacheLoadPromise]);

  // Don't track anything if the network failed
  if (fetchResult.status === 'rejected') {
    return;
  }
  const {
    totalSizeBytes,
    patchSizeBytes,
    patchSizePct
  } = await runWorker({
    namespace,
    entityName,
    cacheKey,
    current: normalizeForPatchDiffing(fetchResult.value, {
      keyBy
    }),
    previous: cacheLoadResult.status === 'fulfilled' ? normalizeForPatchDiffing(cacheLoadResult.value.data, {
      keyBy
    }) : null
  });

  // This is the standardized "did this data change since the prior request" metric
  // It relies on indexeddb reads/writes, so it is async.
  return trackDataChanges({
    isCacheMiss: cacheLoadResult.status === 'rejected',
    namespace,
    entityName,
    cacheKey,
    segment,
    totalSizeBytes,
    patchSizeBytes,
    patchSizePct,
    resolvePortalAndUserId
  });
};